import { gsap } from 'gsap'

import { CustomEase } from 'gsap/CustomEase'
import { animHomeBanner } from './animation.js'
gsap.registerPlugin(CustomEase)

const rmMQ = window.matchMedia("(prefers-reduced-motion: reduce)")
let reducedMotion = rmMQ.matches
let staggerDefault = 0.05
let durationDefault = 0.4
let transitionDurationDefault = 0.9

CustomEase.create('osmo', '0.625, 0.05, 0, 1')
gsap.defaults({ ease: 'osmo', duration: durationDefault })

export const runPageOnceAnimation = (next) => {
  const tl = gsap.timeline()

  tl.call(() => {
    resetPage(next)
  }, null, 0)

  return tl
}

export const runPageLeaveAnimation = (current, next) => {
  const transitionWrap = document.querySelector("[data-transition-wrap]");
  const transitionDark = transitionWrap.querySelector("[data-transition-dark]");

  const tl = gsap.timeline({
    onComplete: () => {
      current.remove(); 
    }
  })
  
  CustomEase.create("parallax", "0.7, 0.05, 0.13, 1");
  
  if (reducedMotion) {
    // Immediate swap behavior if user prefers reduced motion
    return tl.set(current, { autoAlpha: 0 });
  }
  
  tl.set(transitionWrap, {
    zIndex: 2
  });
  
  tl.fromTo(transitionDark, {
    autoAlpha: 0
  },{
    autoAlpha: 0.8,
    duration: 1,
    ease: "parallax"
  }, 0);
  
  tl.fromTo(current,{
    y: "0vh"
  },{
    y: "-25vh",
		opacity: 0.2,
    duration: 1,
    ease: "parallax",
  }, 0);
  
  tl.set(transitionDark, {
    autoAlpha: 0,
  });

  return tl;
}

export const runPageEnterAnimation = (next) => {
  const tl = gsap.timeline();
  
  if (reducedMotion) {
    // Immediate swap behavior if user prefers reduced motion
    tl.set(next, { autoAlpha: 1 });
    tl.add("pageReady")
    tl.call(resetPage, [next], "pageReady");
    return new Promise(resolve => tl.call(resolve, null, "pageReady"));
  }
  
  tl.add("startEnter", 0);
  
  tl.set(next, {
    zIndex: 3
  });
  
  tl.fromTo(next, {
    y: "100vh"
  }, {
    y: "0vh",
    duration: 1,
    clearProps: "all",
    ease: "parallax"
  }, "startEnter");

	tl.add(() => {
		animHomeBanner()
	}, '-=0.5')

  tl.add("pageReady");
  tl.call(resetPage, [next], "pageReady");

  return new Promise(resolve => {
    tl.call(resolve, null, "pageReady");
  });
}

export const resetPage = (container) => {
	window.scrollTo(0, 0)
	gsap.set(container, { clearProps: 'position,top,left,right' })
}